import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 40000
})

const AUTH_EXPIRED_CODES = [4011, 4031, 4032, -4]
const AUTH_EXPIRED_TEXT = /令牌超时|非法令牌|登录过期|禁止匿名/

let clearingAuth = false

function pickPayload(error) {
  return (error && error.response && error.response.data) || {}
}

function isAuthExpired(error) {
  const status = error && error.response && error.response.status
  const payload = pickPayload(error)
  const code = payload.code
  const message = String(payload.message || payload.msg || error.message || '')
  return status === 401
    || status === 403
    || AUTH_EXPIRED_CODES.includes(Number(code))
    || AUTH_EXPIRED_TEXT.test(message)
}

function clearExpiredAuth() {
  if (clearingAuth || !getToken()) {
    return
  }
  clearingAuth = true
  store.dispatch('user/logout')
  Message.error('登录已过期，请重新登录')
  window.setTimeout(() => {
    clearingAuth = false
  }, 800)
}

request.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data && AUTH_EXPIRED_CODES.includes(Number(data.code))) {
      clearExpiredAuth()
    }
    return data
  },
  (error) => {
    if (isAuthExpired(error)) {
      clearExpiredAuth()
      return Promise.reject(error)
    }
    const payload = pickPayload(error)
    const message = payload.message || payload.msg || error.message || '请求失败'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default request
